import { useMutation, useQueryClient } from '@tanstack/react-query';
import { applyFavoriteExerciseSession } from '../../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../../services/refetch-queries';
import { useState } from 'react';

const useApplyFavoriteSession = (targetDate) => {
    const queryClient = useQueryClient();
    const [isApplying, setIsApplying] = useState(false);

    const mutation = useMutation({
        mutationFn: applyFavoriteExerciseSession,
        onError: (error) => {
            console.error('Failed to apply favorite session:', error);
        }
    });

    const applyFavorite = async (payload) => {
        setIsApplying(true);

        try {
            await mutation.mutateAsync(payload);
            await refetchDiaryAndEnergy(queryClient, targetDate);
        } finally {
            setIsApplying(false);
        }
    };

    return {
        applyFavorite,
        isApplying,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useApplyFavoriteSession;
